import {UserAvatar} from '@frontend/components/UserAvatar'
import clsx from 'clsx'

// Логотип Dotoku вместо обложки, если у объявления или услуги нет фото.
export const chatCoverPlaceholder: string = '/img/apple-touch-icon.png'

interface Props {
    coverImage: string | null
    userName: string
    // Крупная обложка для строки списка чатов на десктопе.
    large?: boolean
    // Маленькая обложка для заголовка чата в мини-чате.
    small?: boolean
}

// Обложка объявления или исполнителя с аватаром собеседника в углу.
export function ChatCover(props: Props) {

    const {
        coverImage,
        userName,
        large,
        small,
    } = props

    return (
        <div className={clsx('chat-cover position-relative flex-shrink-0', large && 'large', small && 'small')}>
            <div
                className="img rounded-7"
                style={{
                    backgroundImage: `url("${coverImage || chatCoverPlaceholder}")`,
                }}
            />
            <UserAvatar
                userName={userName}
                className="fs-8"
            />
        </div>
    )
}
